
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import Select from 'react-select'
export const AllEvents = ({data, params, onChange}) => {
  const intl = useIntl()
  const [device, setDevice] = useState(
    params && params.device ? params.device : {value: '', label: 'All'}
  )


  useEffect(() => {
    let newParams = {
      device: device,
 
    }
    onChange(newParams);
  }, [device])
  return (
    <>
      <div className='row mb-6'>
        <div className='col-md-12'>
          <label htmlFor='device' className=' fw-bold fs-6'>
            {intl.formatMessage({
              id: 'SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.DEVICE_FILTER',
            })}
          </label>
          <Select
            name='device'
            options={[
              {value: '', label: 'All'},
              ...data.devices.map((cat: any) => ({
                value: cat.DevHandle + '.' + cat.ChanHandle,
                label: cat.DevDesc,
              })),
            ]}
            classNamePrefix='select'
            onChange={(selectedOption) => {
              setDevice(selectedOption)
            }}
            value={device}
          />
        </div>
      </div>
    
    </>
  )
}
